import { RowDataNotification } from "../../components/Notification/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the NotificationTable factory
 */
class NotificationRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/notifications/read-range"
        this.accessData = "notifications"
    }

    create(notification: any): RowDataNotification {
        const rowDataNotification: RowDataNotification = {
            id: notification.notifications_id,
            title: notification.title,
            body: notification.body,
            type: notification.type,
            route: notification.route,
            send: false,
            action: "",
        };
        return rowDataNotification;
    }

    generateParams(params: any, extra: any): any {
        params["uid"] = extra.uid
        params["current"] = extra.current
        return params
    }
}

let notificationRow: NotificationRow | null = null;

export default function getNotificationRow(): NotificationRow {
    if (notificationRow === null)
        notificationRow = new NotificationRow()
    return notificationRow
}